import { createPublicClient, http } from 'viem'
import {larissaChain} from "@/configs/chain";

export const publicClient = createPublicClient({
    chain: larissaChain,
    transport: http()
})
